import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TextDataResponse } from "src/app/common/model/TextDataResponse";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})

export class AllPlantsService {
    constructor(protected http: HttpClient) {

    }

    baseurl = environment.apiBaseUrl;

    getAllPlantsReport(merchantLB, onsite) : Observable<TextDataResponse> {
        return this.http.get<TextDataResponse>(this.baseurl + 'plant/getAllplantsreports' + '/' + merchantLB + '/' + onsite);
    }
}